import { ObjectTypeIdRegex } from '../filterQueryFormat/ObjectTypeId';
import I18n from 'I18n';
const isV0LifecycleStageProperty = field => field.get('name').startsWith('hs_lifecyclestage_');
export const disableLifecycleStageProperties = (assetFamily, data) => {
  if (!ObjectTypeIdRegex.test(assetFamily)) {
    return data;
  }
  return data.map(field => {
    const shouldHide = isV0LifecycleStageProperty(field);
    if (shouldHide) {
      return field.merge({
        disabled: true,
        tooltip: I18n.text(`customerDataFiltersUI.customerDataFilters.LifecycleStateProperties.tooltip`)
      });
    }
    return field;
  });
};